import { useSelector } from "react-redux";

import { useMorphablePackGroupActions } from "store/MorphablePackGroupSlice";

const useMorphablePackGroup = () => {
  const { loadMorphablePackGroup } = useMorphablePackGroupActions();
  const { morphablePackGroup } = useSelector((state) => state.MorphablePackGroupSlice);

  return { loadMorphablePackGroup, morphablePackGroup };
};

export default useMorphablePackGroup;
